import React, { useRef, useState } from 'react'
import ImageGallery from 'react-image-gallery'
import { useFormattedImagesWithDescription } from '@core/components/ProductDetail/ProductImage/ProductImageHelper'
import config from '@core/config/config'
import { CloseOutlined } from '@ant-design/icons'
import styles from '@core/components/ProductDetail/ProductImage/index.module.less'
import { useTranslation } from '@core/i18n/i18n'

interface FullSizeGalleryProps {
  images: any[]
  imagesToShow: number
  renderItemFunction?: any
}

const FullsizeImageGallery: React.FC<FullSizeGalleryProps> = (props) => {
  const { t } = useTranslation()
  const { images, imagesToShow, renderItemFunction } = props
  const imagesWithDescription = useFormattedImagesWithDescription(images)

  const [isFullScreen, setIsFullScreen] = useState(false)
  const [showClickInfo, setShowClickInfo] = useState(false)

  const galleryRef = useRef<ImageGallery>(null)
  const fullScreenGalleryRef = useRef<ImageGallery>(null)

  const setFullScreen = (isFullscreen: boolean) => {
    setIsFullScreen(isFullscreen)
  }

  const openFullSize = () => {
    if (!config.features.fullSizeImageGallery.enabled) {
      return
    }
    galleryRef.current?.fullScreen()
  }

  const renderFullScreenCloseBtn = () => {
    return (
      <CloseOutlined
        className="image-gallery-icon image-gallery-fullscreen-button"
        onClick={() => fullScreenGalleryRef.current?.exitFullScreen()}
        aria-label="Close Fullscreen"
        rev={undefined}
      />
    )
  }

  if (!images) return null
  const showCarouselArrows = images.length > imagesToShow
  return isFullScreen ? (
    <ImageGallery
      ref={fullScreenGalleryRef}
      items={imagesWithDescription}
      showPlayButton={false}
      showThumbnails={imagesWithDescription.length > 0}
      showNav={true}
      showBullets={true}
      showIndex={true}
      renderFullscreenButton={renderFullScreenCloseBtn}
      onScreenChange={setFullScreen}
    />
  ) : (
    <>
      <ImageGallery
        items={images}
        showPlayButton={false}
        showFullscreenButton={false}
        showThumbnails={images.length > 0}
        onMouseOver={() => setShowClickInfo(true)}
        onMouseLeave={() => setShowClickInfo(false)}
        showNav={showCarouselArrows}
        onScreenChange={setFullScreen}
        ref={galleryRef}
        onClick={openFullSize}
        renderItem={renderItemFunction ? renderItemFunction : null}
      />
      {showClickInfo ? (
        <div className={styles.zoomHint}>{t('product.image.clickToZoom')}</div>
      ) : null}
    </>
  )
}

export default FullsizeImageGallery
